export default __webpack_public_path__ + "static/media/3.47dcb7a1.webp";